import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      const redirect = location.state?.from || (u.role === "admin" || u.role === "super_admin" ? "/admin" : (u.role === "photographer" ? "/studio" : "/"));
      navigate(redirect, { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-6" data-testid="login-page">
      <div className="w-full max-w-sm">
        <p className="text-xs uppercase tracking-[0.4em] text-white/40 mb-3">Welcome back</p>
        <h1 className="font-serif text-4xl font-light mb-10">Sign in</h1>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-white/40 block mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input-minimal"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-white/40 block mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input-minimal"
              data-testid="login-password"
            />
          </div>

          {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}

          <button
            type="submit"
            disabled={busy}
            className="w-full bg-white text-black py-4 text-xs uppercase tracking-[0.3em] font-medium hover:bg-white/90 transition disabled:opacity-50"
            data-testid="login-submit"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="text-sm text-white/50 mt-8 text-center">
          New here?{" "}
          <Link to="/register" className="text-white underline-offset-4 hover:underline" data-testid="link-register">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
